import { LogicBlock } from './logic-block.js'
import { jsonClass, jsonProperty } from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { Expression } from '../../data/text-or-code.js'

@jsonClass('IgnoreValidationsBlock')
export class IgnoreValidationsBlock extends LogicBlock {
	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Ignore validations',
		codeLanguage: 'ts',
		tsReturnType: () => 'any',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
	})
	ignoreValidationsCode = new Expression('false')

	constructor(init: Partial<IgnoreValidationsBlock> = {}) {
		super()
		this.init(init)
	}

	getEditorTitle() {
		return 'Ignore validations'
	}

	getEditorCategory(): string {
		return 'Logic'
	}
}
